import { useState } from "react";
import axios from "axios";

// Imports de Navbar y contexto si los tienes
import { NavBarAdm } from "../Components/NavBarAdm";

//Import Hooks
import { useDataContext } from "../Context/dataContext";
import { useAxiosInterceptors } from "../Hooks/useAxiosInterceptors";
import { useBanks } from "../Hooks/useBanks";

// Import de Iconos
import { FaUniversity, FaPlus } from "react-icons/fa";

function Banks() {
  // Context and hooks
  useAxiosInterceptors();
  const { url, accessToken } = useDataContext();
  const { bankGbp, bankEur, bankUsd } = useBanks(accessToken.access_token);

  const filteredBanks = [...bankEur, ...bankUsd, ...bankGbp].filter((Bank) => {
    const fullName =
      `${Bank.acceur_Bank} ${Bank.accusd_Bank} ${Bank.accgbp_Bank}`.toLowerCase();
    return fullName;
  });

  const [showModal, setShowModal] = useState(false);

  // State for the form
  const [currency, setCurrency] = useState("");
  const [acceur_Bank, setAcceur_Bank] = useState("");
  const [accusd_Bank, setAccusd_Bank] = useState("");
  const [accgbp_Bank, setAccgbp_Bank] = useState("");
  const [acceur_owner, setAcceur_owner] = useState("");
  const [accusd_owner, setAccusd_owner] = useState("");
  const [accgbp_owner, setAccgbp_owner] = useState("");
  const [acceur_number, setAcceur_number] = useState("");
  const [accusd_number, setAccusd_number] = useState("");
  const [accgbp_number, setAccgbp_number] = useState("");
  const [acceur_nie, setAcceur_nie] = useState("");
  const [accusd_Ident, setAccusd_Ident] = useState("");
  const [accgbp_Ident, setAccgbp_Ident] = useState("");
  const [acceur_swift, setAcceur_swift] = useState("");
  const [accusd_email, setAccusd_email] = useState("");
  const [accgbp_swift, setAccgbp_swift] = useState("");
  const [acceur_phone, setAcceur_phone] = useState("");
  const [accusd_phone, setAccusd_phone] = useState("");
  const [accgbp_phone, setAccgbp_phone] = useState("");
  const [accgbp_codSucursal, setAccgbp_codSucursal] = useState("");

  // Function to open the modal
  const openModal = () => {
    setCurrency("");
    setShowModal(true);
  };

  // Function to close the modal and reset form fields
  const closeModal = () => {
    setShowModal(false);
    setAcceur_Bank("");
    setAcceur_owner("");
    setAcceur_number("");
    setAcceur_nie("");
    setAcceur_swift("");
    setAcceur_phone("");

    setAccgbp_Bank("");
    setAccgbp_owner("");
    setAccgbp_number("");
    setAccgbp_Ident("");
    setAccgbp_swift("");
    setAccgbp_codSucursal("");
    setAccgbp_phone("");

    setAccusd_Bank("");
    setAccusd_owner("");
    setAccusd_email("");
    setAccusd_number("");
    setAccusd_Ident("");
    setAccusd_phone("");

    setCurrency("");
  };

  // Function to handle bank status changes
  const handleStatus = async (bank) => {
  try {
    const configs = [
      {
        key: "acceur_status",
        id: bank.acceur_id,
        urlPath: "Acceur",
        statusKey: "acceur_status",
      },
      {
        key: "accusd_status",
        id: bank.accusd_id,
        urlPath: "Accusd",
        statusKey: "accusd_status",
      },
      {
        key: "accgbp_status",
        id: bank.accgbp_id,
        urlPath: "Accgbp",
        statusKey: "accgbp_status",
      },
    ];

    for (const config of configs) {
      if (bank[config.key] === "Desactivo" || bank[config.key] === "Activo") {
        await axios.put(
          `${url}/${config.urlPath}/${config.id}`,
          {
            [config.statusKey]: bank[config.key] === "Desactivo" ? "Activo" : "Desactivo",
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken.access_token}`,
            },
          }
        );
        break; // Solo actualiza el primero que coincida
      }
    }
  } catch (error) {
    console.log(error);
  } finally {
    window.location.reload();
  }
};

  // Function to handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (currency === "EUR") {
      try {
        await axios.post(
          `${url}/Acceur/create`,
          {
            acceur_Bank,
            acceur_owner,
            acceur_number,
            acceur_nie,
            acceur_swift,
            acceur_phone,
            acceur_type: "Normal",
            acceur_status: "Activo",
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken.access_token}`,
              "Content-Type": "application/json",
            },
          }
        );


        closeModal();
      } catch (error) {
        console.log(error);
      } finally {
        window.location.reload();
      }
    }

    if (currency === "GBP") {
      try {
        await axios.post(
          `${url}/Accgbp/create`,
          {
            accgbp_Bank,
            accgbp_owner,
            accgbp_number,
            accgbp_Ident,
            accgbp_swift,
            accgbp_codSucursal,
            accgbp_phone,
            accgbp_status: "Activo",
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken.access_token}`,
              "Content-Type": "application/json",
            },
          }
        );

        closeModal();
      } catch (error) {
        console.log(error);
      } finally {
        window.location.reload();
      }
    }

    if (currency === "USD") {
      try {
        await axios.post(
          `${url}/Accusd/create`,
          {
            accusd_Bank,
            accusd_owner,
            accusd_email,
            accusd_number,
            accusd_Ident,
            accusd_phone,
            accusd_type: "Normal",
            accusd_status: "Activo",
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken.access_token}`,
              "Content-Type": "application/json",
            },
          }
        );

        closeModal();
      } catch (error) {
        console.log(error);
      } finally {
        window.location.reload();
      }
    }
  };

  return (
    <div className="banks-page">
      <div className="banks-container">
        <div className="banks-header">
          <h2>Bancos Registrados</h2>
          <button className="btn-add" onClick={openModal}>
            <FaPlus /> Agregar Banco
          </button>
        </div>

        <table className="banks-table">
          <thead>
            <tr>
              <th>Icono</th>
              <th>Banco</th>
              <th>IBAN</th>
              <th>SWIFT</th>
              <th>Titular</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {filteredBanks
              .filter(
                (bank) =>
                  bank.acceur_Bank !== "Ghost" &&
                  bank.accgbp_Bank !== "Ghost" &&
                  bank.accusd_Bank !== "Ghost"
              )
              .map((bank) => (
                <tr key={bank.acceur_id || bank.accgbp_id || bank.accusd_id}>
                  <td>
                    <FaUniversity size={20} />
                  </td>
                  <td>
                    {bank.acceur_Bank
                      ? bank.acceur_Bank
                      : bank.accusd_Bank
                      ? bank.accusd_Bank
                      : bank.accgbp_Bank}
                  </td>
                  <td>
                    {bank.acceur_number
                      ? bank.acceur_number
                      : bank.accusd_number
                      ? bank.accusd_number
                      : bank.accgbp_number}
                  </td>
                  <td>
                    {bank.acceur_swift
                      ? bank.acceur_swift
                      : bank.accusd_email
                      ? bank.accusd_email
                      : bank.accgbp_swift}
                  </td>
                  <td>
                    {bank.acceur_owner
                      ? bank.acceur_owner
                      : bank.accusd_owner
                      ? bank.accusd_owner
                      : bank.accgbp_owner}
                  </td>
                  <td>
                    <button
                      className={`btn-status ${
                        (bank.acceur_status ||
                          bank.accgbp_status ||
                          bank.accusd_status) === "Activo"
                          ? "Desactivo"
                          : "Activo"
                      }`}
                      onClick={() => handleStatus(bank)}
                    >
                      {(bank.acceur_status ||
                        bank.accgbp_status ||
                        bank.accusd_status) === "Activo"
                        ? "Desactivar"
                        : "Activar"}
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>

        {showModal && (
          <div className="modal show">
            <div className="modal-content">
              <h3>Agregar Banco</h3>
              <form onSubmit={handleSubmit}>
                <label>Moneda:</label>
                <select
                  value={currency}
                  onChange={(e) => setCurrency(e.target.value)}
                  required
                >
                  <option value="">Selecciona una</option>
                  <option value="EUR">EUR</option>
                  <option value="USD">USD</option>
                  <option value="GBP">GBP</option>
                </select>
                {currency === "EUR" ? (
                  <>
                    <label>
                      Nombre del Banco:
                      <input
                        type="text"
                        name="acceur_Bank"
                        value={acceur_Bank}
                        onChange={(e) => setAcceur_Bank(e.target.value)}
                        required
                      />
                    </label>
                    <label>
                      Titular de la Cuenta:
                      <input
                        type="text"
                        name="acceur_owner"
                        value={acceur_owner}
                        onChange={(e) => setAcceur_owner(e.target.value)}
                        required
                      />
                    </label>
                    <label>
                      Número de Cuenta:
                      <input
                        type="text"
                        name="acceur_number"
                        value={acceur_number}
                        onChange={(e) => setAcceur_number(e.target.value)}
                        required
                      />
                    </label>
                    <label>
                      NIE/NIF:
                      <input
                        type="text"
                        name="acceur_nie"
                        value={acceur_nie}
                        onChange={(e) => setAcceur_nie(e.target.value)}
                        required
                      />
                    </label>
                    <label>
                      CONCEPTO                      
                      <input
                        type="text"
                        name="acceur_swift"
                        value={acceur_swift}
                        onChange={(e) => setAcceur_swift(e.target.value)}
                        required
                      />
                    </label>
                    <label>
                      Teléfono:
                      <input
                        type="text"
                        name="acceur_phone"
                        value={acceur_phone}
                        onChange={(e) => setAcceur_phone(e.target.value)}
                        required
                      />
                    </label>
                  </>
                ) : currency === "GBP" ? (
                  <>
                    <label>
                      Nombre del Banco:
                      <input
                        type="text"
                        name="accgbp_Bank"
                        value={accgbp_Bank}
                        onChange={(e) => setAccgbp_Bank(e.target.value)}
                        required
                      />
                    </label>
                    <label>
                      Titular de la Cuenta:
                      <input
                        type="text"
                        name="accgbp_owner"
                        value={accgbp_owner}
                        onChange={(e) => setAccgbp_owner(e.target.value)}
                        required
                      />
                    </label>
                    <label>
                      Número de Cuenta:
                      <input
                        type="text"
                        name="accgbp_number"
                        value={accgbp_number}
                        onChange={(e) => setAccgbp_number(e.target.value)}
                        required
                      />
                    </label>
                    <label>
                      Identificación:
                      <input
                        type="text"
                        name="accgbp_Ident"
                        value={accgbp_Ident}
                        onChange={(e) => setAccgbp_Ident(e.target.value)}
                        required
                      />
                    </label>
                    <label>
                      CONCEPTO
                      <input
                        type="text"
                        name="accgbp_swift"
                        value={accgbp_swift}
                        onChange={(e) => setAccgbp_swift(e.target.value)}
                        required
                      />
                    </label>
                    <label>
                      Código de Sucursal:
                      <input
                        type="text"
                        name="accgbp_codSucursal"
                        value={accgbp_codSucursal}
                        onChange={(e) => setAccgbp_codSucursal(e.target.value)}
                        required
                      />
                    </label>
                    <label>
                      Teléfono:
                      <input
                        type="text"
                        name="accgbp_phone"
                        value={accgbp_phone}
                        onChange={(e) => setAccgbp_phone(e.target.value)}
                        required
                      />
                    </label>
                  </>
                ) : currency === "USD" ? (
                  <>
                    <label>
                      Nombre del Banco:
                      <input
                        type="text"
                        name="accusd_Bank"
                        value={accusd_Bank}
                        onChange={(e) => setAccusd_Bank(e.target.value)}
                        required
                      />
                    </label>
                    <label>
                      Titular de la Cuenta:
                      <input
                        type="text"
                        name="accusd_owner"
                        value={accusd_owner}
                        onChange={(e) => setAccusd_owner(e.target.value)}
                        required
                      />
                    </label>
                    <label>
                      Correo Electrónico:
                      <input
                        type="email"
                        name="accusd_email"
                        value={accusd_email}
                        onChange={(e) => setAccusd_email(e.target.value)}
                        required
                      />
                    </label>
                    <label>
                      Número de Cuenta:
                      <input
                        type="text"
                        name="accusd_number"
                        value={accusd_number}
                        onChange={(e) => setAccusd_number(e.target.value)}
                        required
                      />
                    </label>
                    <label>
                      Identificación:
                      <input
                        type="text"
                        name="accusd_Ident"
                        value={accusd_Ident}
                        onChange={(e) => setAccusd_Ident(e.target.value)}
                        required
                      />
                    </label>
                    <label>
                      CONCEPTO
                      <input
                        type="text"
                        name="accusd_phone"
                        value={accusd_phone}
                        onChange={(e) => setAccusd_phone(e.target.value)}
                        required
                      />
                    </label>
                  </>
                ) : null}
                <div className="modal-actions">
                  <button type="submit" className="btn-save">
                    Guardar
                  </button>
                  <button
                    type="button"
                    className="btn-cancel"
                    onClick={closeModal}
                  >
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
      <NavBarAdm />
    </div>
  );
}

export { Banks };
